import React from "react";
import "../styles/TestimonialsSection.css";

function TestimonialsSection() {
  return (
    <section className="testimonials">
      <h2>What Our Customers Say</h2>
      <blockquote>
        {
          '"Wibitec provided us with top-notch components and excellent customer service. Highly recommend!"'
        }
      </blockquote>
    </section>
  );
}

export default TestimonialsSection;
